import { ensureFloat, ensureInteger, ensureString } from '@/mixins/useEnsure'
import BrowserService from '@/services/browserService'

export default (user, userId, cart, eventName) => {
  if (cart && cart.cartProducts) {
    const products = cart.cartProducts.map((item) => {
      return {
        id: ensureString(item.productID),
        name: item.name,
        favorite: false,
        categories: item.categories.map((c) => {
          return c.title
        }),
        labels: item.properties.map((p) => {
          return p.name
        }),
        availability: 'stock',
        price: ensureFloat(item.price),
        currency: item.currencyCode,
        discount: 0,
        quantity: item.quantity,
      }
    })

    const mixes = cart.cartMixes.map((item) => {
      return {
        id: ensureString(item.mixID),
        name: item.name,
        favorite: item.isFavorite,
        categories: [item.kind],
        labels: [],
        availability: 'stock',
        price: ensureFloat(item.price),
        currency: item.currencyCode,
        discount: 0,
        quantity: item.quantity,
      }
    })

    const items = [...products, ...mixes]

    let discount = null
    if (cart?.discountItems?.length) {
      discount = cart?.discountItems[0]
    }

    const payload = {
      event: eventName,
      platform: BrowserService.platform(),
      sessionId: BrowserService.sessionId(),
      currency: cart.currencyCode,
      value: ensureFloat(cart.productPriceWithoutVat),
      payment: ensureFloat(cart.totalPrice),
      tax: ensureFloat(cart.totalVat),
      shipping: cart.selectedTransport ? ensureFloat(cart.selectedTransport.priceWithoutVat) : 0,
      sale: discount?.discountType,
      coupon: discount?.discountCode,
      discount: discount ? ensureFloat(discount?.totalPrice) * ensureInteger(discount?.quantity) : 0,
      credits: ensureFloat(cart.credits),
      payment_type: cart.selectedPayment?.name,
      shipping_type: cart.selectedTransport?.name,
      ecommerce: {
        currency: cart.currencyCode,
        products: items,
        user: user,
      },
      _clear: true,
    }
    if (userId) payload.user_id = userId
    window.dataLayer?.push(payload)
  }
}
